























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import User from "../../../store/entities/user";
import { GetCommunityAll } from "@/api/pdCommunity/index";
import {  GetUserRoles } from '../../../api/dialysisProcess'
import {
  GetDiseaseTypes
} from "@/api/pdReferral";
@Component
export default class CreateUser extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  user: User = new User();
  communityList: any = [];
  DiseaseTypes: any = [];
  RoleList = []; //角色列表
  get roles() {
    return this.$store.state.user.roles;
  }

  get isHeadNurse() {
    return this.RoleList.findIndex((item:any)=> item.roleName=='护士长')!==-1;
  }

  async getUserRoles(){
    let res = await GetUserRoles()
    this.RoleList = res.objects;
  }
  save() {
    (this.$refs.userForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.user.password = Util.Encrypt(this.user.password);
        this.user.confirmPassword = Util.Encrypt(this.user.confirmPassword);
        await this.$store.dispatch({
          type: "user/create",
          data: this.user
        });
        (this.$refs.userForm as any).resetFields();
        this.$emit("save-success");
        this.getUserRoles();
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.userForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  validatePass = (rule: any, value: any, callback: any) => {
    if (!value) {
      callback(new Error("密码不能为空"));
    } else {
      if (value.length < 6) {
        callback(new Error("密码长度不能小于6位"));
      } else {
        if (!/(?=.*[0-9])(?=.*[a-zA-Z])/.test(value)) {
          callback("密码必须包含字母和数字");
        } else {
          callback();
        }
      }
    }
  };
  validatePassCheck = (rule: any, value: any, callback: any) => {
    if (!value) {
      callback(new Error(this.L("ConfirmPasswordMsg")));
    } else if (value !== this.user.password) {
      callback(new Error(this.L("ConfirmPasswordNotMatch")));
    } else {
      callback();
    }
  };
  userRule = {
    userName: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("UserName")),
        trigger: "blur"
      }
    ],
    name: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Name")),
        trigger: "blur"
      }
    ],
    surname: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Surname")),
        trigger: "blur"
      }
    ],
  /*  emailAddress: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Email")),
        trigger: "blur"
      },
      { type: "email" }
    ],*/
    password: [
      {
        validator: this.validatePass,
        trigger: "blur"
      }
    ],
    confirmPassword: { validator: this.validatePassCheck, trigger: "blur" }
  };

  async created() {
    this.getUserRoles();
    let res = await GetCommunityAll();
    this.communityList = res.objects;
    let res1 = await GetDiseaseTypes();
    this.DiseaseTypes = res1;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/user/create-user.vue